window.loggerColor="red"
window.dsactivatelogger=false;
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'
import './barba'
import SliderVideo from './components/SliderVideo.js'
import Worklist from "./components/Worklist.js"
import HeaderVideo from './components/HeaderVideo'
import HomepageTransition from './components/HomepageTransition'
import ModalInfo from './components/ModalInfo.js'
import Newsletter from './components/Newsletter.js'
import ModalInfoButton from './components/ModalInfoButton.js'
import Cursor from './components/Cursor.js'
import MobileMenu from './components/MobileMenu.js'
import StudioVideo from './components/StudioVideo'
import StudioGallery from './components/StudioGallery'
import PageTitleTransformer from './components/PageTitleTransformer'
import MomentumSlider from "./components/MomentumSlider"
import MainContent from "./components/MainContent"
import SliderImage from "./components/SliderImage";

window.serviceItemsPositions= ['0px', '-100px', '100px'],
// Global get CSRF token function (used by forms).
window.getToken = async () => {
    return await fetch('/!/DynamicToken/refresh')
        .then((res) => res.json())
        .then((data) => {
            return data.csrf_token
        })
        .catch(function (error) {
            this.error = 'Something went wrong. Please try again later.'
        })
}


window.Alpine = Alpine
Alpine.plugin(persist)
Alpine.plugin(intersect)

Alpine.data('worklist', Worklist)
Alpine.data('sliderVideo', SliderVideo)
Alpine.data('sliderImage', SliderImage)
Alpine.data('headerVideo', HeaderVideo)
Alpine.data('homepageTransition', HomepageTransition)
Alpine.data('modalInfo', ModalInfo)
Alpine.data('modalInfoButton', ModalInfoButton)
Alpine.data('momentumSlider', MomentumSlider)
Alpine.data('studioVideo', StudioVideo)
Alpine.data('studioGallery', StudioGallery)
Alpine.data('newsletter', Newsletter)
Alpine.data('mobileMenu', MobileMenu)
Alpine.data('pageTitleTransformer', PageTitleTransformer)
Alpine.data('mainContent', MainContent)
// Slider('.swiper')
SliderVideo();
Cursor();

//ModalInfo();
//HomepageTransition();

// Call Alpine.

Alpine.start()

